<template>
  <div class="form">
    <div class="form-field row mb-3">
      <template v-for="field in fields">
        <form-field
          v-model="value[field.model]"
          :label="field.label"
          :id="field.id"
          :placeholder="field.placeholder"
          :type="field.type"
          :options="field.options"
          :mask="field.mask"
          :required="field.required"
          :disabled="field.disabled"
          :accept="field.accept"
          :form-wrapper-class="field.formWrapperClass || 'col-md-7'"
        />
      </template>
    </div>
  </div>
</template>

<script>
import FormField from "./FormField";
export default {
  name: "FormGroup",
  components: { FormField },
  props: {
    value: {
      type: Object,
      default: ""
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    },
    validate() {}
  }
};
</script>

<style lang="scss"></style>
